var cart_button = document.querySelector('.site-header .control-cart .btn-header-cart');
var cart_dropdown = document.querySelector('.cart-dropdown-container');
var accordions = document.querySelectorAll('.accordion-item');
var accordion_open_triggers = document.querySelectorAll('.accordion-item-passed .accordion-item-header, .accordion-item-open .accordion-item-header');
var fav_delete_triggers = document.querySelectorAll('.favourite-delete');
var modal_btns = document.querySelectorAll('[data-modal]');
var category_filters = document.querySelector('.category-filters');
var select_delivery = document.querySelector('.select-delivery');
var cart_price = document.getElementById('update-price');
var delivery_country = document.getElementById('l_delivery_country');
var delivery_express = document.getElementById('l_delivery_express_group');
var masonry_grid = document.querySelector('.category-grid-container .wrapper');
var update_cart = document.querySelectorAll('.update-cart-form');

const debounce = (callback, wait) => {
    let timeoutId = null;
    return (...args) => {
      window.clearTimeout(timeoutId);
      timeoutId = window.setTimeout(() => {
        callback.apply(null, args);
      }, wait);
    };
}

// popup cookie

function setCookie(cname, cvalue, exdays) {
    var d = new Date();
    d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
    var expires = "expires=" + d.toUTCString();
    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}

function getCookie(cname) {
    var name = cname + "=";
    var decodedCookie = decodeURIComponent(document.cookie);
    var ca = decodedCookie.split(';');
    for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == ' ') {
            c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
            return c.substring(name.length, c.length);
        }
    }
    return "";
}

function checkCookie() {
    const popup = document.querySelector('.popup-container');
  
    if (popup) {
      const { id } = popup.dataset;
  
      const exists = getCookie('popup');
      if (exists !== id) {
        popup.classList.add('is-active');
      }
  
      const closeButton = document.querySelector('.popup-container .close');
      if (closeButton) {
        closeButton.addEventListener('click', () => {
          setCookie('popup', id, 365);
          popup.classList.remove('is-active');
        });
      }
    }
}

checkCookie();

// Delivery country
if (delivery_country) {
    delivery_country.addEventListener('change', function (e) {
        if (delivery_country.options[delivery_country.selectedIndex].value == 'HU') {
            showElem(delivery_express);
        } else {
            hideElem(delivery_express);
        }
    });
}

// Cart dropdown
if (cart_button && cart_dropdown) {
    cart_button.addEventListener('click', function (e) {
        e.preventDefault();
        if (window.innerWidth > 700) {
            toggleClass(this, 'btn-header-cart-open');
            toggleElem(cart_dropdown);
        } else {
            window.location = this.getAttribute('href');
        }
    });
}

// function ProductSingleQuantityChanged(e) {
//     var form = this.parentElement.parentElement;
//     var url = form.getAttribute('data-url') + '?amount=' + form.querySelector('input[name=quantity]').value + '&product=' + form.querySelector('input[name=product]').value;
//     var $this = this;
//     var data = getAjax(url, function (data) {
//         var json = JSON.parse(data);
//         if (!json.error) {
//             document.getElementById('unit-price-net').innerHTML = json.unit_price_without_tax;
//             document.getElementById('unit-price-gros').innerHTML = json.unit_price_with_tax;
//             document.getElementById('amount-price-net').innerHTML = json.without_tax;
//             document.getElementById('amount-price-gros').innerHTML = json.with_tax;
//         }
//         if (json.note) {
//             form.querySelector('.price-note').innerHTML = json.note;
//             form.querySelector('.price-note').setAttribute('style', 'display: block;');
//         } else {
//             form.querySelector('.price-note').innerHTML = '';
//             form.querySelector('.price-note').setAttribute('style', 'display: none;');
//         }
//     });
// }

// if (cart_price) {
//     cart_price.addEventListener('click', ProductSingleQuantityChanged);
// }

// const ProdutSingleQuantity = document.querySelector('.product-cart-container #price-quantity');
// if (ProdutSingleQuantity) {
//     ProdutSingleQuantity.addEventListener('change', ProductSingleQuantityChanged);
// }

// Deleting favs
// if (fav_delete_triggers) {
//     forEach(fav_delete_triggers, function (index, elem) {
//         elem.addEventListener('click', function (e) {
//             var tag = this.nextElementSibling;
//
//             if (tag) {
//                 e.preventDefault();
//                 toggleElem(delete_tag);
//             }
//         });
//     });
// }

// Masonry grid
if (masonry_grid) {
    var msnry = new Masonry(masonry_grid, {
        itemSelector: '.category-item',
        columnWidth: '.grid-sizer',
        gutter: '.gutter-sizer',
        percentPosition: true
    });
}

// Accordions
if (accordion_open_triggers) {
    forEach(accordion_open_triggers, function (index, elem) {
        elem.addEventListener('click', function (e) {
            e.preventDefault();

            var section = document.querySelector('.accordion-item[data-step="' + elem.dataset.open + '"]');
            var content = section.querySelector('.accordion-item-content');
            var fields = content.querySelectorAll('.form-input');

            if (content) {
                if (hasClass(section, 'accordion-item-open')) {
                    removeClass(section, 'accordion-item-open');
                    hideElem(content);

                    forEach(fields, function (index, elem) {
                        elem.disabled = 'disabled';
                    });
                } else {
                    removeClass('.accordion-item-open', 'accordion-item-open');
                    hideByClass('accordion-item-content');
                    addClass(section, 'accordion-item-open');
                    showElem(content);

                    forEach(fields, function (index, elem) {
                        elem.disabled = false;
                    });
                }
            }
        });
    });

    forEach(accordions, function (index, elem) {
        var content = elem.querySelector('.accordion-item-content');
        var fields = content.querySelectorAll('.form-input');

        if (hasClass(elem, 'accordion-item-open')) {
            forEach(fields, function (index, elem) {
                elem.disabled = false;
            });
        } else {
            forEach(fields, function (index, elem) {
                elem.disabled = 'disabled';
            });
        }
    });
}

// Enable delivery address modification
if (select_delivery) {
    var delivery_block = document.getElementById('delivery-toggle-block');

    forEach(select_delivery.querySelectorAll('input[type=radio]'), function (index, elem) {
        elem.addEventListener('change', function () {
            if (this.checked && this.dataset.delivery == 'true') {
                showElem(delivery_block);
                inputValue('l_delivery_name', inputValue('l_billing_name'));
                inputValue('l_delivery_zip', inputValue('l_billing_zip'));
                inputValue('l_delivery_city', inputValue('l_billing_city'));
                inputValue('l_delivery_address', inputValue('l_billing_address'));
                inputValue('l_delivery_country', inputValue('l_billing_country'));
            } else {
                hideElem(delivery_block);
            }
        });
    });
}

// Modals
if (modal_btns.length) {
    forEach(modal_btns, function (index, elem) {
        elem.addEventListener('click', function (e) {
            e.preventDefault();

            var target = e.target.dataset.modal;
            document.getElementById('modal-' + target).style.display = 'block';
            window.scrollTo(0, 50);
        });
    });

    // Closing modals
    var modal_close_btns = document.querySelectorAll('[data-modal-close]');

    if (modal_close_btns) {
        forEach(modal_close_btns, function (index, elem) {
            elem.addEventListener('click', function (e) {
                e.preventDefault();
                var modals = document.getElementsByClassName('modal-container');

                for (var i = 0; i < modals.length; i++) {
                    modals[i].style.display = 'none';
                }
            });

            // Close on ESC key
            document.addEventListener('keyup', function(e) {
                if (e.keyCode == 27) {
                    var modals = document.getElementsByClassName('modal-container');

                    for (var i = 0; i < modals.length; i++) {
                        modals[i].style.display = 'none';
                    }
                }
            });

        });
    }
}

// Sliders
if (category_filters) {
    var filter_form = document.querySelector('.category-filter-form');
    var qtty_form = document.querySelector('.category-quantity-form');
    var ranges = category_filters.querySelectorAll('.range-filter');
    var checkboxes = category_filters.querySelectorAll('.check-filter');

    function submitFilters() {
        var qtty = qtty_form.querySelector('input[name=quantity]');
        var input = document.createElement('input');

        input.type = 'hidden';
        input.name = 'quantity';
        input.value = qtty.value;

        filter_form.appendChild(input);
        filter_form.submit();
    }

    function submitQuantity() {
        var filters = filter_form.querySelectorAll('input');

        forEach(filters, function (index, elem) {
            var input = document.createElement('input');
            input.type = 'hidden';
            input.name = elem.name;
            input.value = elem.value;

            qtty_form.appendChild(input);
        });

        qtty_form.submit();
    }

    qtty_form.addEventListener('submit', function (e) {
        e.preventDefault();
        submitQuantity();
    });

    if (checkboxes.length) {
        forEach(checkboxes, function (index, elem) {
            elem.addEventListener('change', function () {
                submitFilters();
            });
        });
    }

    if (ranges.length) {
        forEach(ranges, function (index, elem) {
            var slider = elem.querySelector('.filter-slider');
            var set_min = elem.querySelector('input[type=hidden]:nth-child(1)');
            var set_max = elem.querySelector('input[type=hidden]:nth-child(2)');
            var range_min = parseInt(elem.querySelector('.filter-value.pull-left').innerHTML);
            var range_max = parseInt(elem.querySelector('.filter-value.pull-right').innerHTML);
            var sliderValues = [
                elem.querySelector('.filter-value.pull-left'),
                elem.querySelector('.filter-value.pull-right')
            ];

            noUiSlider.create(slider, {
                start: [parseInt(set_min.value), parseInt(set_max.value)],
                connect: true,
                step: 1,
                // snap: true,
                range: {
                    'min': range_min,
                    'max': range_max
                },
                format: wNumb({
                    decimals: 0
                })
            });

            slider.noUiSlider.on('update', function (values, handle) {
                sliderValues[handle].innerHTML = values[handle];
            });

            slider.noUiSlider.on('change', function (values, handle, a, b, handlePositions) {
                set_min.value = values[0];
                set_max.value = values[1];

                submitFilters();
            });
        });
    }
}

// Updating cart
if (update_cart) {
    forEach(update_cart, function (index, elem) {
        elem.addEventListener('submit', function (e) {
            e.preventDefault();
            checkPrice(elem);
        });
    });
}

// cart dropdown update on quantity change with ajax

const cartDropdownQuantityChanged = debounce(function(item) {
// console.log('changed');
    if (parseInt(item.value) < parseInt(item.getAttribute('min')) ||
    parseInt(item.value) % parseInt(item.getAttribute('step')) > 0) {
        item.setCustomValidity('A megadható mennyiség ' + item.getAttribute('step') + ' db, vagy annak többszöröse!');
        item.reportValidity();
        return false;
    }

    item.setCustomValidity('');

    const url = item.form.action;
    const id = item.form.querySelector('input[name="item"]');
    const product = item.form.querySelector('input[name="product"]');

    let params = '?item=' + id.value + '&quantity=' + item.value;

    var request = new XMLHttpRequest();
    request.open('GET', url + params, true);
    request.onload = function() {
        if (request.readyState > 3 && request.status == 200) {
            var data = JSON.parse(request.responseText);

            if (data) {
                for (const [key, item] of Object.entries(data.cart_contents)) {
                    const itemPrices = document.querySelectorAll('form[data-id="' + key + '"] .cart-price');
                    const itemPricesTotal = document.querySelectorAll('form[data-id="' + key + '"] .cart-price-total');

                    if (itemPrices) {
                        itemPrices.forEach(elem => {
                            const net = elem.querySelector('.price-net');
                            if (net) {
                                net.innerText = item.price;
                            }

                            const gross = elem.querySelector('.price-gross');
                            if (gross) {
                                gross.innerText = item.price_with_tax;
                            }
                        });
                    }

                    if (itemPricesTotal) {
                        itemPricesTotal.forEach(elem => {
                            const net = elem.querySelector('.price-net');
                            if (net) {
                                net.innerText = item.total;
                            }

                            const gross = elem.querySelector('.price-gross');
                            if (gross) {
                                gross.innerText = item.total_with_tax;
                            }
                        });
                    }
                }

                const cartTotal = document.querySelector('.cart-dropdown-container .cart-status .cart-value');
                if (cartTotal) {
                    cartTotal.innerText = data.total;
                }

                const cartShipping = document.querySelector('.cart-dropdown-container .cart-status .cart-shipping');
                if (cartShipping) {
                    cartShipping.innerHTML = data.delivery;
                }

                const sumValues = document.querySelectorAll('.aside-summary-container .sum-values');
                if (sumValues) {
                    sumValues.forEach(elem => {
                        const net = elem.querySelector('.value-net');
                        if (net) {
                            net.innerText = data.total_value;
                        }

                        const gross = elem.querySelector('.value-gross');
                        if (gross) {
                            gross.innerText = data.total_value_with_tax;
                        }
                    });
                }
            }
        }
    };
    request.onerror = function(e) {
        console.error(e);
    };
    request.send();
}, 500);

const cartDropdownQuantities = document.querySelectorAll('form.cart-dropdown-form input[name="quantity"]');
if (cartDropdownQuantities) {
    cartDropdownQuantities.forEach(item => {
        item.addEventListener('input', function() {
            cartDropdownQuantityChanged(item);
        });
    });
}

// cart dropdown delete item

const cartDropdownDeletes = document.querySelectorAll('form.cart-dropdown-form .btn-cart-delete');
if (cartDropdownDeletes) {
    cartDropdownDeletes.forEach(item => {
        item.addEventListener('click', e => {
            const url = item.dataset.url;

            var request = new XMLHttpRequest();
            request.open('GET', url, true);
            request.onload = function() {
                if (request.readyState > 3 && request.status == 200) {
                    var data = JSON.parse(request.responseText);

                    if (data) {
                        const cartItem = document.querySelector('form[data-id="' + data.id + '"]');
                        if (cartItem) {
                            cartItem.parentNode.parentNode.removeChild(cartItem.parentNode);
                        }

                        const headerCart = document.querySelector('.btn-header-cart');
                        if (headerCart) {
                            headerCart.innerHTML = `<i class="fa fa-shopping-cart"></i> <span class="header-cart-amount">${data.count.split(' ')[0]}</span>`;
                        }

                        const cartTotal = document.querySelector('.cart-dropdown-container .cart-status .cart-value');
                        if (cartTotal) {
                            cartTotal.innerText = data.total;
                        }

                        const cartShipping = document.querySelector('.cart-dropdown-container .cart-status .cart-shipping');
                        if (cartShipping) {
                            cartShipping.innerHTML = data.delivery;
                        }
                    }
                }
            };
            request.onerror = function(e) {
                console.error(e);
            };
            request.send();
        });
    });
}

var browser = document.documentElement;
browser.setAttribute('data-useragent',  navigator.userAgent);
browser.setAttribute('data-platform', navigator.platform );

var PriceUpdateSelect = document.querySelectorAll('.update-price');

if (PriceUpdateSelect) {
    for (let i = 0; i < PriceUpdateSelect.length; i++) {
        PriceUpdateSelect[i].addEventListener('change', function () {
            let product = this.parentNode.parentNode,
                prices = product.querySelector('.price'),
                discounts = this.querySelectorAll('option')[this.selectedIndex]

            if (product && prices) {
                prices.querySelector('.show-price-net').innerHTML = discounts.dataset.priceNet
                prices.querySelector('.show-price-gros').innerHTML = discounts.dataset.priceGros
            }
        });
    }
}

// let PriceCalculator = document.querySelector('.price-calculator');

// if (PriceCalculator) {
//     PriceCalculator.addEventListener('submit', function (e) {
const PriceCalculator = document.querySelector('.price-calculator input');
if (PriceCalculator) {
    PriceCalculator.addEventListener('change', debounce(function(e) {
        e.preventDefault();

        let unit = PriceCalculator.value;
        const step = PriceCalculator.step;

        if (unit % step !== 0) {
            // ha nem oszthato a csomagolasi egyseggel, akkor kerekiti
            unit = PriceCalculator.value = Math.round(unit / step) * step;
        }

        if (unit) {
            let products = document.querySelectorAll('.product-list-item')

            for (let i = 0; i < products.length; i++) {
                let product_id = products[i].dataset.productId;
                let sale_min = products[i].dataset.minSale;

                if (product_id) {
                    // `${e.currentTarget.action}?product=${product_id}&amount=${unit}`
                    const url = `${PriceCalculator.dataset.action}?product=${product_id}&amount=${unit}`;
                    fetch(url)
                        .then(response => response.json())
                        .then(data => {
                            products[i].querySelector('.show-price-net').innerHTML = new String(data.unit_price_without_tax_plain)
                            products[i].querySelector('.show-price-gros').innerHTML = new String(data.unit_price_with_tax)
                            products[i].querySelector('input[name="quantity"]').setAttribute('value', sale_min > unit?sale_min:unit)
                            // console.log(products[i].querySelector('input[name="quantity"]'))
                            const select = products[i].querySelector('.update-price');
                            if (select) {
                                const opts = select.querySelectorAll('option');
                                let biggest = opts[0];

                                opts.forEach(item => {
                                    const val = item.value.substr(0, item.value.indexOf('-'));
                                    const prev = biggest.value.substr(0, biggest.value.indexOf('-'));
                                    if (parseInt(val) <= parseInt(unit) && parseInt(val) > parseInt(prev)) {
                                        biggest = item;
                                    }
                                });

                                if (biggest) {
                                    biggest.selected = true;
                                }
                            }
                        })
                }
            }
        }
    }, 500));
}

// category list item quantity change

const productListItem = document.querySelectorAll('.product-list .product-list-item:not(.product-list-header)');

if (productListItem) {
    productListItem.forEach((productItem) => {
        const updateCartForm = document.querySelector('.product-list-item[data-product-id="'+productItem.dataset.productId+'"] .form-control.update-cart-form');

        if (updateCartForm) {
            const qtty = updateCartForm.querySelector('input[name="quantity"]');

            if (qtty) {
                qtty.addEventListener('change', debounce(function(e) {
                    e.preventDefault();

                    const qtty = e.target;
                    const step = qtty.step;
                    const product_id = qtty.dataset.productId;
                    let unit = qtty.value;

                    if (unit % step !== 0) {
                        // ha nem oszthato a csomagolasi egyseggel, akkor kerekiti
                        unit = qtty.value = Math.round(unit / step) * step;
                    }

                    const url = `${updateCartForm.dataset.url}?product=${product_id}&amount=${unit}`;

                    qtty.setAttribute('disabled', 'disabled');

                    fetch(url)
                        .then(response => response.json())
                        .then(data => {
                            if (data.error == 0) {
                                const net = productItem.querySelector('.price .show-price-net');

                                if (net) {
                                    let value = data.unit_price_without_tax_plain.replaceAll(' ', '')
                                        .replace('Ft', '')
                                        .replace('+áfa', '')
                                        .replace(',', '.')
                                        .trim();

                                    // value = (value / qtty.value).toFixed(1);

                                    net.innerText = new Intl.NumberFormat('hu-HU', { style: 'currency', currency: 'HUF' }).format(value);
                                }

                                const gross = productItem.querySelector('.price .show-price-gros');

                                if (gross) {
                                    let value = data.unit_price_with_tax.replaceAll(' ', '')
                                        .replace('Ft', '')
                                        .replace('+áfa', '')
                                        .replace(',', '.')
                                        .trim();

                                    // value = (value / qtty.value).toFixed(1);

                                    gross.innerText = new Intl.NumberFormat('hu-HU', { style: 'currency', currency: 'HUF' }).format(value);
                                }
                            }

                            qtty.removeAttribute('disabled');
                        })
                }, 500));
            }
        }
    });
}

// product page quantity change

function productQuantityChanged(e) {
    e.preventDefault();

    const qtty = e.target;
    let unit = qtty.value;
    const step = qtty.step;

    if (unit % step !== 0) {
        // ha nem oszthato a csomagolasi egyseggel, akkor kerekiti
        unit = qtty.value = Math.round(unit / step) * step;
    }

    let product_id = qtty.dataset.productId;

    qtty.setAttribute('disabled', 'disabled');

    if (product_id) {
        // `${e.currentTarget.action}?product=${product_id}&amount=${unit}`
        const url = `${qtty.dataset.action}?product=${product_id}&amount=${unit}`;
        fetch(url)
            .then(response => response.json())
            .then(data => {
                if (data.error == 0) {
                    const net = qtty.form.querySelector('#unit-price-net');

                    if (net) {
                        let value = data.without_tax.replaceAll(' ', '')
                            .replace('Ft', '')
                            .replace('+áfa', '')
                            .replace(',', '.')
                            .trim();

                        value = (value / qtty.value).toFixed(1);

                        net.innerText = new Intl.NumberFormat('hu-HU', { style: 'currency', currency: 'HUF' }).format(value) + ' + áfa / db';
                    }

                    const gross = qtty.form.querySelector('#unit-price-gros');

                    if (gross) {
                        let value = data.with_tax.replaceAll(' ', '')
                            .replace('Ft', '')
                            .replace('+áfa', '')
                            .replace(',', '.')
                            .trim();

                        value = (value / qtty.value).toFixed(1);

                        gross.innerText = new Intl.NumberFormat('hu-HU', { style: 'currency', currency: 'HUF' }).format(value);
                    }

                    // osszesen

                    const amount_net = qtty.form.querySelector('#amount-price-net');

                    if (amount_net) {
                        amount_net.innerText = new String(data.without_tax);
                    }

                    const amount_gross = qtty.form.querySelector('#amount-price-gros');

                    if (amount_gross) {
                        amount_gross.innerText = new String(data.with_tax);
                        amount_gross.setAttribute('title', new String(data.with_tax));
                    }
                }

                qtty.removeAttribute('disabled');

                // products[i].querySelector('.show-price-net').innerHTML = new String(data.unit_price_without_tax_plain)
                // products[i].querySelector('.show-price-gros').innerHTML = new String(data.unit_price_with_tax)
                // products[i].querySelector('input[name="quantity"]').setAttribute('value', unit)
            })
    }
};

// const qtties = document.querySelectorAll('.product-cart-controls .update-cart-form input[name="quantity"]');
// if (qtties) {
//     qtties.forEach(qtty => {
//         qtty.addEventListener('change', e => {
//             e.preventDefault();
//             const unit = qtty.value;

//             let product_id = qtty.dataset.productId;

//             if (product_id) {
//                 // `${e.currentTarget.action}?product=${product_id}&amount=${unit}`
//                 const url = `${qtty.dataset.action}?product=${product_id}&amount=${unit}`;
//                 fetch(url)
//                     .then(response => response.json())
//                     .then(data => {
//                         if (data.error == 0) {
//                             const net = qtty.form.querySelector('#unit-price-net');

//                             if (net) {
//                                 let value = data.without_tax.replaceAll(' ', '')
//                                     .replace('Ft', '')
//                                     .replace('+áfa', '')
//                                     .replace(',', '.')
//                                     .trim();

//                                 value = (value / qtty.value).toFixed(1);

//                                 net.innerText = new Intl.NumberFormat('hu-HU', { style: 'currency', currency: 'HUF' }).format(value) + ' + áfa / db';
//                             }

//                             const gross = qtty.form.querySelector('#unit-price-gros');

//                             if (gross) {
//                                 let value = data.with_tax.replaceAll(' ', '')
//                                     .replace('Ft', '')
//                                     .replace('+áfa', '')
//                                     .replace(',', '.')
//                                     .trim();

//                                 value = (value / qtty.value).toFixed(1);

//                                 gross.innerText = new Intl.NumberFormat('hu-HU', { style: 'currency', currency: 'HUF' }).format(value);
//                             }

//                             // osszesen

//                             const amount_net = qtty.form.querySelector('#amount-price-net');

//                             if (amount_net) {
//                                 amount_net.innerText = new String(data.without_tax);
//                             }

//                             const amount_gross = qtty.form.querySelector('#amount-price-gros');

//                             if (amount_gross) {
//                                 amount_gross.innerText = new String(data.with_tax);
//                                 amount_gross.setAttribute('title', new String(data.with_tax));
//                             }
//                         }

//                         // products[i].querySelector('.show-price-net').innerHTML = new String(data.unit_price_without_tax_plain)
//                         // products[i].querySelector('.show-price-gros').innerHTML = new String(data.unit_price_with_tax)
//                         // products[i].querySelector('input[name="quantity"]').setAttribute('value', unit)
//                     })
//             }

//             // const listItem = qtty.closest('.product-list-item');
//             // if (listItem) {
//             //     const updatePrice = listItem.querySelector('.update-price');
//             //     if (updatePrice) {
//             //         const opts = updatePrice.querySelectorAll('option');
//             //         let biggest = opts[0];

//             //         opts.forEach(item => {
//             //             const val = item.value.substr(0, item.value.indexOf('-'));
//             //             const prev = biggest.value.substr(0, biggest.value.indexOf('-'));
//             //             if (parseInt(val) <= parseInt(unit) && parseInt(val) > parseInt(prev)) {
//             //                 biggest = item;
//             //             }
//             //         });

//             //         if (biggest) {
//             //             biggest.selected = true;
//             //             const product = updatePrice.parentNode.parentNode,
//             //                 prices = product.querySelector('.price');

//             //             if (product && prices) {
//             //                 prices.querySelector('.show-price-net').innerHTML = biggest.dataset.priceNet;
//             //                 prices.querySelector('.show-price-gros').innerHTML = biggest.dataset.priceGros;
//             //             }
//             //         }
//             //     }
//             // }
//         });
//     });
// }

// Kosar tovabb gomb-ra mennyiseg check

const formCartSummary = document.querySelector('.form-cart-summary');
if (formCartSummary) {
    formCartSummary.addEventListener('submit', (e) => {
        const qtties = document.querySelectorAll('.cart-dropdown-form input[name="quantity"]');
        if (qtties) {
            qtties.forEach(item => {
                if (parseInt(item.value) < parseInt(item.getAttribute('min')) ||
                parseInt(item.value) % parseInt(item.getAttribute('step')) > 0) {
                    e.preventDefault();
                    item.setCustomValidity('A megadható mennyiség ' + item.getAttribute('step') + ' db, vagy annak többszöröse!');
                    item.reportValidity();

                    return false;
                }

                item.setCustomValidity('');
            });
        }
    });
}

const cartCloseButton = document.querySelector('.close-cart-button');

if (cartCloseButton) {
    cartCloseButton.addEventListener('click', e => {
        e.preventDefault();

        cart_button.click();
    });
}
